import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CrudService } from '../../shared/services/crud.service';
import { EmailTemplateFilter } from './email-template.type';

@Injectable({
    providedIn: 'root'
})
export class EmailTemplateFilterService extends CrudService<EmailTemplateFilter> {
    constructor(protected http: HttpClient) {
        super(http, 'emailTemplateFilter');
    }

    filteredObjects(id: number, emailTemplateId: number): Observable<Array<string>> {
        return this.http.get<Array<string>>(
            `/api/${this.apiUrl}/${id}/filteredObjects?emailTemplateId=${emailTemplateId}`
        );
    }
}
